import React, { useState, useEffect } from "react";
import Header from "../../../Common/Layout/Header";
import { useAuth } from "../../../Common/Configurations/AuthContext";
import SearchFlightPanel1 from "../SearchFlightPanel/SearchFlightPanel1"; // This will now use the new panel
import AirlineOffers from "../../../Components/Advertisements/AirlineOffers";
import { useNavigate } from "react-router-dom";

const SearchFlight1 = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [currency, setCurrency] = useState(user?.currency);

  const handleCurrencyChange = (newCurrency) => {
    setCurrency(newCurrency);
  };

  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }

  return (
    <div id="layout-wrapper">
      <Header User={user} activeSection="flights" />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            
              <div className="p-2">
            
              </div>
              <SearchFlightPanel1 /> {/* This now uses the new styled component */}
           
            <AirlineOffers />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchFlight1;